import { Text, View } from "@react-pdf/renderer";
import { formatMoney } from "infra/helpers/number";
import colors from "core/resources/theme/colors";

interface PDFSummaryItemProps {
  title: string;
  leftTitle?: string;
  value?: number;
  valueColor?: string;
  bordered?: boolean;
}

function PDFSummaryItem({
  title,
  leftTitle,
  value,
  valueColor = colors.black,
  bordered,
}: PDFSummaryItemProps) {
  return (
    <View
      style={{
        justifyContent: "space-between",
        color: valueColor,
        borderBottomWidth: bordered ? 2 : 0,
        borderColor: colors.black500,
        paddingBottom: 2,
        marginBottom: 4,
        flexDirection: "row",
        fontSize: 8,
      }}
    >
      <Text style={{ fontWeight: "medium" }}>{title}</Text>
      {leftTitle !== undefined ? (
        <Text style={{ fontWeight: "medium" }}>{leftTitle}</Text>
      ) : null}
      {value !== undefined ? (
        <Text style={{ fontWeight: "bold" }}>{formatMoney(value)}</Text>
      ) : null}
    </View>
  );
}

export default PDFSummaryItem;
